module.exports = __webpack_public_path__ + "files/59a324fb171b6ff236a026deddb76f99.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/roboto-bold-webfont.svg
 ** module id = 994
 ** module chunks = 0
 **/